module.exports = __webpack_public_path__ + "fa6189405dd21ed6c05b3516d287e66c.pdf";